import _ from 'lodash';
import { createSelector } from 'reselect';
import { NAME } from './constants';
import * as actionTypes from './actionTypes';
import { selectors as coreSelectors } from '../core';

const getStore = state => state[NAME];
const getItems = state => getStore(state).items;
const getIds = state => _.get(getStore(state), 'ids', []);

export const getAuditLogs = createSelector(
    getItems,
    getIds,
    (items, ids) => _.map(ids, id => items[id])
);

export const getAuditLogsPagination = createSelector(
    getStore,
    store => _.get(store, 'pagination', {})
);

export const isGettingAuditLogs = state =>
    coreSelectors.isLoading(state, actionTypes.GET_AUDIT_LOGS.NAME);

export const getAuditAdmins = state => _.get(getStore(state), 'admins', []);
